import { apiKeyClient } from "@better-auth/api-key/client";
import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import { stripeClient } from "@better-auth/stripe/client";
import type { auth } from "@repo/auth";
import { ac, roles } from "@repo/auth/access-control";
import {
  inferAdditionalFields,
  organizationClient,
} from "better-auth/client/plugins";
import type { AccessControl } from "better-auth/plugins/access";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_DOMAIN_API,
  fetchOptions: {
    credentials: "include",
  },
  plugins: [
    // Cast to the wider `AccessControl` type — better-auth's `OrganizationClientOptions["ac"]`
    // is invariant in its statements generic, so a narrowed-statements `ac` doesn't
    // structurally satisfy the wider type without an assertion.
    organizationClient({
      ac: ac as AccessControl,
      roles,
      schema: {
        organization: {
          additionalFields: {
            onboarding: {
              type: "string",
              required: false,
              defaultValue: "done",
            },
            slackChannelId: {
              type: "string",
              required: false,
            },
            slackChannelName: {
              type: "string",
              required: false,
            },
            slackChannelConnectedAt: {
              type: "date",
              required: false,
            },
            slackInviteUrl: {
              type: "string",
              required: false,
            },
            slackInviteSentAt: {
              type: "date",
              required: false,
            },
          },
        },
      },
    }),
    stripeClient({ subscription: true }),
    apiKeyClient(),
    // Exposes `authClient.oauth2.*` (consent / continue / publicClient) for the
    // OAuth consent + org-selection pages, and auto-forwards the signed
    // `oauth_query` from the URL on sign-in/consent so the authorization flow
    // continues across the cross-origin redirect to these pages.
    oauthProviderClient(),
    inferAdditionalFields<typeof auth>(),
  ],
});
